module.exports = __webpack_public_path__ + "static/media/rUSD.81f116f4.svg";